// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2g71u","title":"Info_title__vXT3k","selects":"Info_selects__lB1sh","requiredAsterisk":"Info_requiredAsterisk__1d6VD"};